/** Where the login page sends a user after sign-in when no valid `next` is given. */
export const DEFAULT_POST_LOGIN_URL = '/admin.html';

/**
 * Resolves the login page's `?next=` parameter to a same-origin path. Anything
 * that isn't a plain absolute path (another origin, `//host`, `/\host`, a
 * `javascript:` URL) falls back to the dashboard, so the parameter can't be
 * used to bounce a freshly signed-in user to someone else's site.
 */
export function safeNextUrl(next: string | null): string {
  if (!next || !next.startsWith('/') || next.startsWith('//') || next.startsWith('/\\')) {
    return DEFAULT_POST_LOGIN_URL;
  }
  return next;
}

/** Login URL that returns the user to the current page after sign-in. */
export function loginUrlReturningHere(loginUrl: string, location: Pick<Location, 'pathname' | 'search'> = window.location): string {
  const here = location.pathname + location.search;
  if (here === '/' || here === DEFAULT_POST_LOGIN_URL) return loginUrl;
  return `${loginUrl}?next=${encodeURIComponent(here)}`;
}
